import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js"
import { DisplayFeedbackEvent } from "./feedback-manager";

@customElement("ctx-feedback-button")
export class CtxFeedbackButton extends LitElement {
  static styles = [
    css`
      :host {
        display: inline-block
      }

      .svg-button {
        display:block;
      }
    `
  ];

  @property({ type: Number, attribute:"report-key" }) public reportKey?: number;

  @property({ type: String }) public heading: string = "Feedback";
  @property({ type: String }) public placeHolder?: string;

  feedbackClickedHandler = (e: Event) => {
    this.dispatchEvent(new DisplayFeedbackEvent(this.reportKey, this.heading, this.placeHolder))
  }
  render() {
    return html`<slot>
      <fluent-button @click=${this.feedbackClickedHandler}>
        <mwc-icon slot="start" class="svg-button">contact_support</mwc-icon>
        ${this.heading}
      </fluent-button>
    </slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "ctx-feedback-button": CtxFeedbackButton;
  }
}
